export const ROUTE_BASE = {
  RE: 'resource-explorer',
  PDE: 'private-data-enclave',
  PDC: 'public-data-commons',
};

export const pdeRoutes = {
  projectView: (projectId: string) => ['/', ROUTE_BASE.PDE, 'project', 'view', projectId],

  projectEditDetails: (projectId: string) => ['/', ROUTE_BASE.PDE, 'project', 'edit-details', projectId],

  projectEditAccess: (projectId: string) => ['/', ROUTE_BASE.PDE, 'project', 'edit-access', projectId],

  projectEditAccessDelete: (projectId: string) => [
    '/',
    ROUTE_BASE.PDE,
    'project',
    'edit-access',
    projectId,
    {subsection: 'delete'},
  ],

  datasetView: (datasetId: string) => ['/', ROUTE_BASE.PDE, 'dataset', 'view', datasetId],

  datasetAdd: (projectId: string) => ['/', ROUTE_BASE.PDE, 'dataset', 'add', {project: projectId}],

  datasetEditDetails: (datasetId: string) => ['/', ROUTE_BASE.PDE, 'dataset', 'edit-details', datasetId],

  datasetEditAccess: (datasetId: string) => ['/', ROUTE_BASE.PDE, 'dataset', 'edit-access', datasetId],

  datasetEditAccessDelete: (datasetId: string) => [
    '/',
    ROUTE_BASE.PDE,
    'dataset',
    'edit-access',
    datasetId,
    {subsection: 'delete'},
  ],
};

export const pdcRoutes = {
  projectView: (projectId: string) => ['/', ROUTE_BASE.PDC, 'project', 'view', projectId],

  datasetView: (datasetId: string) => ['/', ROUTE_BASE.PDC, 'dataset', 'view', datasetId],
};
